import XLSX from 'xlsx';
import FileSaver from 'file-saver';

export default {
    data() {
        return {
            // 搜索条件
            form: {
                // 订单号
                code: '',
                // 商户订单号
                merchantCode: '',
                // 第三方支付单号
                thirdPartyCode: '',
                // 学员姓名
                name: '',
                // 身份证号
                idcard: '',
                // 所属单位
                company: '',
                // 订单总金额
                total: '',
                // 订单状态
                state: '',
                // 订单描述
                desc: '',
                // 支付方式
                payType: '',
                // 大于或等于成功支付时间
                payTimeAtEgt: '',
                // 小于或等于成功支付时间
                payTimeAtEglt: '',
            },
            // 订单状态
            orderState: [{
                value: 0,
                label: '未支付',
            },
            {
                value: 2,
                label: '已支付',
            },
            {
                value: 5,
                label: '已失效',
            }
            ],
            // 支付方式
            payType: [{
                value: 1,
                label: '支付宝',
            },
            {
                value: 2,
                label: '微信',
            },
            {
                value: 3,
                label: '批量开课',
            },
            {
                value: 5,
                label: '余额支付',
            },
            {
                value: 6,
                label: '郑州银行',
            },
            ],
            // 表格数据
            tableData: [],
            // 选择的row数组 
            selections: [],
            // 选择的row的id数组
            selectionIds: [],
            // 控制显示修改对话框的变量
            editDialog: false,
            // 需要修改的记录
            record: '',
            // 选择的订单项id
            purchasedIds: [],
            // 控制显示导入对话框的变量
            importDialog: false,
            // 下载导入模板
            download: '',
            // 上传的文件导入地址
            address: 'orders/importOrderExcel',
            // 总条数
            total: 20,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
            // 退款原因
            refundReason: '',
            // 当前选择数据的order_id
            orderId: '',
            // 当前订单的课程包数据
            infoData: [],
            // 导出显示加载中
            exportLoading: false,
            // 导出excel
            excelDialog: false,
            exceldata: {
                offset: 0,
                length: 0
            },
        }
    },
    methods: {
        search() {
            this.currentPage = 1;
            this.getMyorder();
        },

        // 当选择项发生变化时会触发该事件
        handleSelectionChange(selections) {
            if (selections.length > 0) {
                this.record = selections[0];
                this.orderId = selections[0].id;

                this.selections = selections;
                // 取出选择的row的id
                this.selectionIds = selections.map(item => item.id);
            }
        },

        // 修改
        edit() {
            // 先判断是否有选择记录且最多选择一条记录
            if (this.selectionIds.length === 0 || this.selectionIds.length !== 1) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }
            // 获取当前选择订单的课程包数据
            this.getInfoByOrderId();

            // 显示修改的对话框
            this.editDialog = true;
        },

        // 确认修改
        confirmEdit() {
            // 发送请求修改
            this.$message.success('修改成功');

            // 隐藏修改的对话框
            this.editDialog = false;
        },

        // 当选择项发生变化时会触发该事件，是修改对话框的
        handleSelectionChange2(selections) {
            this.purchasedIds = selections.map(item => item.id);
            console.log(this.purchasedIds);
        },

        // 点击退款按钮
        handleRefund() {
            // 先判断是否有选择记录且最多选择一条记录
            if (this.selections == '' || this.selections.length !== 1) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }

            // 提示是否退款
            this.$confirm('是否要退款选择的记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                // 声明退款原因
                this.$prompt('退款原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPlaceholder: '请输入退款原因',
                }).then(({
                    value
                }) => {
                    this.$post('balance_record/refund', {
                        token: this.$store.state.authority_management,
                        order_id: this.selections[0].id,
                        owner_id: this.selections[0].owner_id,
                        refund_Reason: value,
                        note: value,
                    }).then(res => {
                        if (res.data.status === 'success') {
                            this.$message({
                                type: 'success',
                                message: '退款成功!'
                            });
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.errorMsg
                            });
                        }
                        this.getMyorder();
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消退款'
                    });
                });

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消退款'
                });
            });
        },

        // 全部退款
        refundAll() {
            // this.purchasedIds
            // 发送请求全部退款
            this.$message.success('全部退款成功！');
        },

        // 删除
        remove() {
            // 先判断是否有选择记录
            if (this.selectionIds.length === 0) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }

            // 提示
            this.$confirm('是否删除选择的记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.$post('orders/editOrder', {
                    token: this.$store.state.authority_management,
                    order_ids: JSON.stringify(this.selectionIds)
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },

        // 导入
        theImport() {
            this.importDialog = true;
        },

        // 上传excel批量注册用户
        httpreq(q) {
            // console.log(q);
            this.$upload(this.baseUrl + this.address, q).then(res => {
                this.$message({
                    message: '批量注册用户完成，结果如下表',
                    type: 'success'
                });
                this.registerInfo = res.data.result;
            })
        },
        // 每页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getMyorder();
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.getMyorder();
        },

        //获取订单数据
        getMyorder() {
            // // 订单号
            // code: '',
            // // 商户订单号
            // merchantCode: '',
            // // 第三方支付单号
            // thirdPartyCode: '',
            // // 学员姓名
            // name: '',
            // // 身份证号
            // idcard: '',
            // // 所属单位
            // company: '',
            // // 订单总金额
            // total: '',
            // // 订单状态
            // state: '',
            // // 订单描述
            // desc: '',
            this.$post("orders/shop_search", {
                token: this.$store.state.authority_management,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                user_name: this.form.name,
                idCard: this.form.idcard,
                company: this.form.company,
                code: this.form.code,
                state: this.form.state,
                total: this.form.total,
                pay_type: this.form.payType,
                pay_date_egt: this.form.payTimeAtEgt,
                pay_date_elt: this.form.payTimeAtEglt,
            }).then(res => {
                this.tableData = res.data.result.data;
                this.total = res.data.result.total;
                return res.data.result.data;
            });
        },

        // 导出excel
        exportExcel() {
            this.excelDialog = true;
        },

        // 确认导出
        confirmexport() {
            this.exportLoading = true;
            this.excelDialog = false;
            let data = {
                token: this.$store.state.authority_management,
                offset: this.exceldata.offset,
                length: this.exceldata.length
            }
            if (this.form.code) {
                data.code = this.form.code
            }
            if (this.form.merchantCode) {
                data.merchantCode = this.form.merchantCode
            }
            if (this.form.thirdPartyCode) {
                data.thirdPartyCode = this.form.thirdPartyCode
            }
            if (this.form.name) {
                data.name = this.form.name
            }
            if (this.form.idcard) {
                data.idcard = this.form.idcard
            }
            if (this.form.company) {
                data.company = this.form.company
            }
            if (this.form.total) {
                data.total = this.form.total
            }
            if (this.form.state) {
                data.state = this.form.state
            }
            if (this.form.desc) {
                data.desc = this.form.desc
            }
            if (this.form.payType) {
                data.payType = this.form.payType
            }
            if (this.form.payTimeAtEgt) {
                data.payTimeAtEgt = this.form.payTimeAtEgt
            }
            if (this.form.payTimeAtEglt) {
                data.payTimeAtEglt = this.form.payTimeAtEglt
            }

            this.$post('orders/orderExport', data).then(res => {
                this.exportLoading = false;
                window.open(res.data.result)
            })
        },

        // 在输入框输入数据时触发
        inputNumber(e) {
            e >= 20000 ? this.exceldata.length = 20000 : this.exceldata.length = e;
        },

        // 获取订单的课程包数据
        getInfoByOrderId() {
            this.$post('category_order/buyCategory', {
                token: this.$store.state.authority_management,
                order_id: this.orderId,
                offset: 0,
                length: 9999,
            }).then(res => {
                this.infoData = res.data.result;
            });
        },
    },
    filters: {
        orderStateFilter(value) {
            switch (Number.parseInt(value)) {
                case 0:
                    return '未支付';
                case 2:
                    return '已支付';
                case 3:
                    return '已退款';
                case 5:
                    return '已失效';
            }
        },

        payTypeFilter(value) {
            switch (Number.parseInt(value)) {
                case 1:
                    return '支付宝';
                case 2:
                    return '微信';
                case 3:
                    return '批量开课';
                case 5:
                    return '余额支付';
                case 6:
                    return '郑州银行';
            }
        }
    },
    created() {
        this.getMyorder()
        
        if(this.$store.state.store.id === 107){
            this.payType = [{
                value: 1,
                label: '支付宝',
            },
            {
                value: 2,
                label: '微信',
            },
            {
                value: 3,
                label: '批量开课',
            },
            {
                value: 5,
                label: '余额支付',
            },
            {
                value: 6,
                label: '郑州银行',
            },
            ]
        }else{
            this.payType = [{
                value: 1,
                label: '支付宝',
            },
            {
                value: 2,
                label: '微信',
            },
            {
                value: 3,
                label: '批量开课',
            },
            {
                value: 5,
                label: '余额支付',
            },
            ]
        }
    },
}
